import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-275" data-mp="1n0aejjtk0wxo">
      <div className="mx-auto w-full max-w-4xl" data-id="element-276" data-mp="1mzsdm9vy5ujf">
        <p className="text-center text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-277" data-mp="1r146coa4avvu">
          What dental professionals are saying
        </p>

        <div className="mt-5 flex flex-col items-center" data-id="element-278" data-mp="1d47eqkm6dadw">
          <div className="flex items-center gap-1" aria-hidden="true" data-id="element-279" data-mp="1i1qsljeynl5b">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-5 w-5 fill-[#F0A818] text-[#F0A818]" data-id="element-280" data-mp="1439aq2bql2vb" data-mpi={index} />)}
          </div>
          <p className="mt-2 text-2xl font-black text-navy sm:text-3xl" data-id="element-281" data-mp="2yg8rvzvrm54p">
            4.9/5
          </p>
          <p className="mt-2 max-w-md text-center text-[13.5px] text-navy2 sm:text-[15px]" data-id="element-282" data-mp="32fhpjftxen5j">
            Join professionals who are using structured tools to organize their
            aligner workflows.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-283" data-mp="2q0ex4ku56cjl">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-white p-5 shadow-sm" data-id="element-284" data-mp="34t8bg2xogmmo">
              <div className="flex items-center gap-3" data-id="element-285" data-mp="2c38eqrdbyfuw">
                <img src={testimonial.photo} alt={testimonial.name} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-286" data-mp="27459p6xco9mx" />
                <div className="min-w-0" data-id="element-287" data-mp="2h10ajwh3im4d">
                  <p className="text-[14.5px] font-extrabold leading-tight text-navy" data-id="element-288" data-mp="1ang7xjsjvb3">
                    {testimonial.name}
                  </p>
                  <p className="mt-0.5 text-[12px] font-semibold text-navy2/70" data-id="element-289" data-mp="3sfx2be4nzpff">
                    {testimonial.flag} {testimonial.country}
                  </p>
                </div>
              </div>

              <div className="mt-3 flex items-center gap-0.5" aria-hidden="true" data-id="element-290" data-mp="8ck8cjaca7nd">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-[#F0A818] text-[#F0A818]" data-id="element-291" data-mp="ic1c2v616bgp" data-mpi={index} />)}
              </div>

              <blockquote className="mt-3 text-[13.5px] leading-relaxed text-navy2 sm:text-[15px]" data-id="element-292" data-mp="3gru7pjmugyrg">
                “{testimonial.quote}”
              </blockquote>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-md" data-id="element-293" data-mp="3vil0ov06a3w5">
          <CtaButton label="I want to organize my cases" subLabel="Instant access · $27 one-time payment" data-id="element-294" data-mp="3vjcuq1e4ftkb" />
        </div>
      </div>
    </section>;
}